/* ==========================================================================
   NUVÉRA — section behaviour (no dependencies, ~8KB)
   Works with the theme's own <form is="product-form"> and cart drawer:
   the offer module only changes the hidden id / selling_plan inputs and lets
   the theme submit, add to cart and open its drawer as usual.
   ========================================================================== */
(function () {
	'use strict';

	var S = window.nuveraSettings || {};
	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	var STORE_KEY = 'nuvera:offer';

	if (S.motion && !reduceMotion) document.documentElement.classList.add('nv-motion');

	/* ---------- helpers ---------- */
	function track(event, props) {
		if (!S.track) return;
		window.dataLayer = window.dataLayer || [];
		var payload = Object.assign({ event: event, waker: getWaker(), src: getCookie('nv_src') || undefined }, props || {});
		window.dataLayer.push(payload);
		document.dispatchEvent(new CustomEvent('nuvera:track', { detail: payload }));
	}

	function getParam(name) {
		try { return new URLSearchParams(window.location.search).get(name); } catch (e) { return null; }
	}

	function getCookie(name) {
		var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
		return m ? decodeURIComponent(m[1]) : null;
	}

	function setCookie(name, value, days) {
		var d = new Date();
		d.setTime(d.getTime() + days * 864e5);
		document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
	}

	function readStore() {
		try { return JSON.parse(sessionStorage.getItem(STORE_KEY)) || null; } catch (e) { return null; }
	}

	function writeStore(v) {
		try { sessionStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) {}
		document.dispatchEvent(new CustomEvent('nuvera:offer-change', { detail: v }));
	}

	function getWaker() {
		return document.documentElement.getAttribute('data-waker') || 'wired';
	}

	function fill(template, n, price) {
		return String(template || '').replace(/\[N\]/g, n).replace(/\[PRICE\]/g, price);
	}

	/* ---------- URL params: waker, src, utm (B4) ---------- */
	(function params() {
		var waker = getParam('waker');
		if (waker === 'hot' || waker === 'wired') {
			try { sessionStorage.setItem('nuvera:waker', waker); } catch (e) {}
		}
		var stored = null;
		try { stored = sessionStorage.getItem('nuvera:waker'); } catch (e) {}
		document.documentElement.setAttribute('data-waker', waker || stored || 'wired');

		var src = getParam('src');
		if (src) setCookie('nv_src', src, 7);
		['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
			var v = getParam(k);
			if (v) setCookie('nv_' + k, v, 7);
		});
	})();

	// Pass attribution to the cart (→ checkout note attributes) after the first add.
	var attributesSent = false;
	document.addEventListener('variant:add', function () {
		if (attributesSent) return;
		attributesSent = true;
		var attrs = { waker: getWaker() };
		['src', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
			var v = getCookie('nv_' + k);
			if (v) attrs[k] = v;
		});
		fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ attributes: attrs })
		}).catch(function () {});
	});

	/* ---------- Smooth scroll to anchors (CTAs) ---------- */
	document.addEventListener('click', function (e) {
		if (e.defaultPrevented) return;
		var link = e.target.closest('a[href^="#"]');
		if (!link || link.getAttribute('href').length < 2) return;
		var target = document.getElementById(link.getAttribute('href').slice(1));
		if (!target) return;
		e.preventDefault();
		target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
		if (link.hasAttribute('data-nv-cta')) {
			track('cta_click', { cta_location: link.getAttribute('data-nv-cta'), destination: link.getAttribute('href') });
		}
		// move focus for keyboard and screen-reader users without a second jump
		if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
		target.focus({ preventScroll: true });
	});

	/* ---------- Observers ---------- */
	function observeOnce(els, threshold, cb) {
		if (!('IntersectionObserver' in window)) { els.forEach(cb); return; }
		var io = new IntersectionObserver(function (entries) {
			entries.forEach(function (en) {
				if (en.isIntersecting) { cb(en.target); io.unobserve(en.target); }
			});
		}, { threshold: threshold });
		els.forEach(function (el) { io.observe(el); });
	}

	function initReveal(root) {
		observeOnce(root.querySelectorAll('.nv-reveal:not(.is-visible)'), 0.15, function (el) { el.classList.add('is-visible'); });
		observeOnce(root.querySelectorAll('[data-nv-divider]'), 0.5, function (el) {
			var tl = el.closest('.nv-timeline');
			if (tl) tl.classList.add('is-revealed');
		});
		observeOnce(root.querySelectorAll('[data-nv-section]'), 0.5, function (el) {
			track('section_view', { section_id: el.getAttribute('data-nv-section') });
		});
		// waker_card_view: 60% in view for ≥ 1.5s
		if ('IntersectionObserver' in window) {
			root.querySelectorAll('[data-waker-card]').forEach(function (card) {
				var timer = null, done = false;
				var io = new IntersectionObserver(function (entries) {
					entries.forEach(function (en) {
						if (done) return;
						if (en.isIntersecting) {
							timer = setTimeout(function () { done = true; io.disconnect(); track('waker_card_view', { card: card.getAttribute('data-waker-card') }); }, 1500);
						} else if (timer) { clearTimeout(timer); }
					});
				}, { threshold: 0.6 });
				io.observe(card);
			});
		}
	}

	/* ---------- Hero gallery ---------- */
	function initGallery(root) {
		root.querySelectorAll('[data-nv-gallery]').forEach(function (g) {
			if (g.__nv) return; g.__nv = true;
			var track_ = g.querySelector('.nv-gallery__track');
			var slides = Array.prototype.slice.call(g.querySelectorAll('.nv-gallery__slide'));
			var controls = Array.prototype.slice.call(g.querySelectorAll('[data-slide-to]'));
			if (!track_ || slides.length < 2) return;
			function setCurrent(i) {
				controls.forEach(function (c) { c.setAttribute('aria-current', String(Number(c.getAttribute('data-slide-to')) === i)); });
			}
			controls.forEach(function (c) {
				c.addEventListener('click', function () {
					var i = Number(c.getAttribute('data-slide-to'));
					track_.scrollTo({ left: slides[i].offsetLeft - track_.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
					setCurrent(i);
				});
			});
			var raf = null;
			track_.addEventListener('scroll', function () {
				if (raf) cancelAnimationFrame(raf);
				raf = requestAnimationFrame(function () {
					var i = Math.round(track_.scrollLeft / track_.clientWidth);
					setCurrent(Math.max(0, Math.min(slides.length - 1, i)));
				});
			}, { passive: true });
		});
	}

	/* ---------- FAQ accordion (multiple may stay open) ---------- */
	function initFaq(root) {
		root.querySelectorAll('.nv-faq__btn').forEach(function (btn) {
			if (btn.__nv) return; btn.__nv = true;
			btn.addEventListener('click', function () {
				var open = btn.getAttribute('aria-expanded') === 'true';
				var panel = document.getElementById(btn.getAttribute('aria-controls'));
				btn.setAttribute('aria-expanded', String(!open));
				if (panel) panel.hidden = open;
				if (!open) track('faq_open', { question_id: btn.getAttribute('data-question-id') });
			});
		});
	}

	/* ---------- Sources disclosure: open on desktop ---------- */
	function initSources(root) {
		if (window.matchMedia('(min-width: 1000px)').matches) {
			root.querySelectorAll('details[data-nv-open-desktop]').forEach(function (d) { d.open = true; });
		}
	}

	/* ---------- Review chips ---------- */
	function initReviewChips(root) {
		root.querySelectorAll('[data-nv-review-chips]').forEach(function (wrap) {
			if (wrap.__nv) return; wrap.__nv = true;
			var chips = Array.prototype.slice.call(wrap.querySelectorAll('[data-filter]'));
			function select(value, silent) {
				chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-filter') === value)); });
				if (!silent) track('review_filter', { filter: value });
				document.dispatchEvent(new CustomEvent('nuvera:review-filter', { detail: { filter: value } }));
			}
			chips.forEach(function (c) { c.addEventListener('click', function () { select(c.getAttribute('data-filter')); }); });
			var waker = getParam('waker');
			if (waker === 'wired' || waker === 'hot') {
				var preset = chips.filter(function (c) { return c.getAttribute('data-filter') === waker; })[0];
				if (preset) select(waker, true);
			}
		});
	}

	/* ---------- Offer module (Section 10) ---------- */
	function initOffer(root) {
		root.querySelectorAll('[data-nv-offer]').forEach(function (offer) {
			if (offer.__nv) return; offer.__nv = true;

			var form = offer.querySelector('form[is="product-form"]');
			if (!form) return;
			var idInput = form.querySelector('input[name="id"]');
			var planInput = form.querySelector('input[name="selling_plan"]');
			var button = offer.querySelector('[data-nv-submit]');
			var buttonLabel = offer.querySelector('[data-nv-submit-label]');
			var terms = offer.querySelector('[data-nv-terms]');
			var kit = offer.querySelector('[data-nv-kit]');
			var images = offer.querySelectorAll('.nv-offer-img');
			var typeInputs = Array.prototype.slice.call(offer.querySelectorAll('input[data-nv-type]'));
			var options = Array.prototype.slice.call(offer.querySelectorAll('input[data-nv-option]'));
			var labelSub = offer.getAttribute('data-label-subscribe');
			var labelOne = offer.getAttribute('data-label-onetime');
			var hasPlans = offer.getAttribute('data-has-plans') === 'true';
			var interacted = false;

			function current() {
				var type = (typeInputs.filter(function (i) { return i.checked; })[0] || {}).value || (hasPlans ? 'subscribe' : 'onetime');
				var opt = options.filter(function (o) { return o.checked; })[0] || options[0];
				return { type: type, opt: opt };
			}

			function render(fromUser) {
				var c = current();
				if (!c.opt) return;
				var d = c.opt.dataset;
				var isSub = c.type === 'subscribe' && d.planId;
				offer.setAttribute('data-type', isSub ? 'subscribe' : 'onetime');

				idInput.value = d.variantId;
				if (planInput) {
					planInput.value = isSub ? d.planId : '';
					planInput.disabled = !isSub;
				}

				// update every option's displayed price for the chosen purchase type
				options.forEach(function (o) {
					var card = o.closest('.nv-option');
					var od = o.dataset;
					var sub = c.type === 'subscribe' && od.planId;
					var priceEl = card.querySelector('[data-nv-price]');
					var compareEl = card.querySelector('[data-nv-compare]');
					var metaEl = card.querySelector('[data-nv-meta]');
					if (priceEl) priceEl.textContent = sub ? od.priceSub : od.priceOne;
					if (compareEl) { compareEl.textContent = sub && od.save ? od.priceOne : ''; compareEl.hidden = !(sub && od.save); }
					if (metaEl) metaEl.textContent = sub ? od.metaSub : od.metaOne;
				});

				var price = isSub ? d.priceSub : d.priceOne;
				if (buttonLabel) buttonLabel.textContent = fill(isSub ? labelSub : labelOne, d.nights, price);
				if (terms) terms.textContent = fill(S.termsLine, d.nights, d.priceSub);
				if (kit) kit.textContent = isSub ? kit.getAttribute('data-sub') : kit.getAttribute('data-one');

				images.forEach(function (img) {
					var src = d.image;
					if (src && img.getAttribute('data-current') !== src) {
						img.setAttribute('data-current', src);
						img.src = src;
						img.removeAttribute('srcset');
					}
				});

				if (button) button.disabled = d.available !== 'true';

				var state = {
					variantId: d.variantId, planId: isSub ? d.planId : null, type: isSub ? 'subscribe' : 'onetime',
					nights: d.nights, price: price, title: d.title, interacted: interacted || !!fromUser
				};
				writeStore(state);
				if (fromUser) {
					interacted = true;
					track('offer_select', { nights: Number(d.nights), type: state.type, price: price });
				}
			}

			typeInputs.concat(options).forEach(function (i) { i.addEventListener('change', function () { render(true); }); });

			// restore a previous selection from this visit (G-03 / Section 10 dev notes)
			var saved = readStore();
			if (saved && saved.variantId) {
				var match = options.filter(function (o) { return o.dataset.variantId === String(saved.variantId); })[0];
				if (match) match.checked = true;
				var t = typeInputs.filter(function (i) { return i.value === saved.type; })[0];
				if (t) t.checked = true;
				interacted = !!saved.interacted;
			}
			render(false);

			// Mobile: one-tap straight to checkout after a successful add (E4)
			form.addEventListener('variant:add', function () {
				track('add_to_cart', { value: current().opt.dataset.priceCents / 100, selling_plan: planInput && !planInput.disabled ? planInput.value : null, nights: Number(current().opt.dataset.nights) });
				if (offer.getAttribute('data-mobile-checkout') === 'true' && window.matchMedia('(max-width: 749px)').matches) {
					track('begin_checkout', {});
					window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
				}
			});

			var errorEl = offer.querySelector('[data-nv-error]');
			form.addEventListener('cart:error', function (e) { if (errorEl) errorEl.textContent = (e.detail && e.detail.error) || ''; });
			form.addEventListener('submit', function () { if (errorEl) errorEl.textContent = ''; });
		});
	}

	/* ---------- Sticky add-to-cart bar (G-03) ---------- */
	function initSticky(root) {
		var bar = root.querySelector ? root.querySelector('[data-nv-sticky]') : null;
		if (!bar || bar.__nv) return; bar.__nv = true;

		var sel = bar.querySelector('[data-nv-sticky-sel]');
		var btn = bar.querySelector('[data-nv-sticky-btn]');
		var btnLabel = bar.querySelector('[data-nv-sticky-label]');
		var anchor = bar.getAttribute('data-offer-anchor') || 'offer';
		var addTemplate = bar.getAttribute('data-add-label') || 'Add to bag — [PRICE]';
		var defaultLabel = btnLabel ? btnLabel.textContent : '';
		var heroCta = document.querySelector('[data-nv-hero-cta]');
		var offerEl = document.getElementById(anchor);
		var pastHero = !heroCta, offerVisible = false;

		function update() {
			var show = pastHero && !offerVisible;
			bar.classList.toggle('is-visible', show);
			bar.setAttribute('aria-hidden', String(!show));
			if (btn) btn.tabIndex = show ? 0 : -1;
		}

		function label(state) {
			if (!state) return;
			if (sel) sel.textContent = state.nights + ' nights · ' + state.price;
			if (btnLabel) btnLabel.textContent = state.interacted ? fill(addTemplate, state.nights, state.price) : defaultLabel;
		}

		label(readStore());
		document.addEventListener('nuvera:offer-change', function (e) { label(e.detail); });

		if ('IntersectionObserver' in window) {
			if (heroCta) {
				new IntersectionObserver(function (en) {
					pastHero = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
					update();
				}).observe(heroCta);
			} else {
				pastHero = false;
				window.addEventListener('scroll', function () { pastHero = window.scrollY > 600; update(); }, { passive: true });
			}
			if (offerEl) {
				new IntersectionObserver(function (en) { offerVisible = en[0].isIntersecting; update(); }, { threshold: 0 }).observe(offerEl);
			}
		}

		if (btn) {
			btn.addEventListener('click', function (e) {
				var state = readStore();
				var form = offerEl ? offerEl.querySelector('form[is="product-form"]') : null;
				track('cta_click', { cta_location: 'sticky', destination: '#' + anchor });
				if (state && state.interacted && form && typeof form.requestSubmit === 'function') {
					e.preventDefault();
					form.requestSubmit();
				}
				// otherwise the link scrolls to #offer via the anchor handler
			});
		}
		update();
	}

	/* ---------- Light / dark mode ---------- */
	var MODE_KEY = 'nuvera:mode';
	function currentMode() { return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'; }
	function syncToggles() {
		var dark = currentMode() === 'dark';
		document.querySelectorAll('[data-nv-mode-toggle]').forEach(function (b) {
			var label = dark ? 'Switch to light mode' : 'Switch to dark mode';
			b.setAttribute('aria-pressed', String(dark));
			b.setAttribute('aria-label', label);
			b.setAttribute('title', label);
		});
	}
	function setMode(mode, remember) {
		var root = document.documentElement;
		if (!reduceMotion) {
			root.classList.add('nv-mode-switching');
			setTimeout(function () { root.classList.remove('nv-mode-switching'); }, 350);
		}
		root.setAttribute('data-theme', mode);
		if (remember) { try { localStorage.setItem(MODE_KEY, mode); } catch (e) {} }
		syncToggles();
		document.dispatchEvent(new CustomEvent('nuvera:mode-change', { detail: { mode: mode } }));
	}
	document.addEventListener('click', function (e) {
		var btn = e.target.closest('[data-nv-mode-toggle]');
		if (!btn) return;
		e.preventDefault();
		var next = currentMode() === 'dark' ? 'light' : 'dark';
		setMode(next, true);
		track('theme_mode', { mode: next });
	});
	// Follow the device setting live, unless the visitor picked a mode
	if (window.nuveraDefaultMode === 'system' && window.matchMedia) {
		var mq = window.matchMedia('(prefers-color-scheme: dark)');
		var onChange = function (ev) {
			var saved = null;
			try { saved = localStorage.getItem(MODE_KEY); } catch (e) {}
			if (!saved) setMode(ev.matches ? 'dark' : 'light', false);
		};
		if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
	}

	function initAll(root) {
		syncToggles();
		root = root || document;
		initReveal(root);
		initGallery(root);
		initFaq(root);
		initSources(root);
		initReviewChips(root);
		initOffer(root);
		initSticky(document);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { initAll(document); });
	} else {
		initAll(document);
	}

	// Theme editor support
	document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
